import dayjs from 'dayjs'

import MediaList from '~components/general/media-list'
import Avatar from '~components/ui/avatar'
import Icon from '~components/ui/icon'
import FormattedAnswerText from '~components/ui/formatted-answer-text'
import SanitizedText from '~components/ui/sanitized-text'
import { Message } from '~models/consultation'

type SenderInfo = Readonly<{
  thumbnailUri: string
  nickname: string
}>

type ConversationProps = Readonly<{
  conversation: Message.Response[] | undefined
  ownerInfo: SenderInfo
  vetInfo: SenderInfo
  withMediaFiles?: boolean
}>

export const Conversation = ({
  conversation,
  ownerInfo,
  vetInfo,
  withMediaFiles = true,
}: ConversationProps) => {
  return (
    <div>
      {conversation?.map(({ sender, text, photo_urls, video_urls, created_at }, index) => {
        const isVet = sender === 'Vet'
        const thumbnailUri = isVet ? vetInfo.thumbnailUri : ownerInfo.thumbnailUri
        const nickname = isVet ? vetInfo.nickname : ownerInfo.nickname

        const hasMediaFiles = !!video_urls?.length || !!photo_urls?.length

        if (isVet) {
          return (
            <div key={index} className="flex items-start flex-gap-x-2 px-5 py-2">
              <Avatar uri={thumbnailUri} size="32" />
              <div className="w-full min-w-0">
                <div className="flex items-center flex-gap-x-1">
                  <div className="flex items-center flex-gap-x-2 text-gray-900 text-title-3">
                    {nickname}
                  </div>
                  <Icon name="badge" className="size-5 fill-primary-500" />
                </div>
                <p className="mt-2 rounded-2xl bg-extended-alabaster p-4 text-gray-900 text-body-2 lg:text-body-3">
                  <FormattedAnswerText text={text} />
                </p>
                <p className="mt-2 block text-gray-500 text-body-3 lg:pb-5 lg:pt-2">
                  {dayjs(created_at).format('MMM DD')}
                </p>
              </div>
            </div>
          )
        }

        return (
          <div key={index} className="flex justify-end flex-gap-x-2 px-5 py-2">
            <div className="flex min-w-0 flex-col items-end flex-gap-y-2">
              <div className="text-gray-900 text-title-3">{nickname}</div>
              <p className="w-full rounded-2xl bg-white px-4 py-3 text-gray-900 text-body-2 lg:text-body-3">
                <SanitizedText text={text} />
              </p>
              {hasMediaFiles && withMediaFiles && (
                <MediaList videoUrls={video_urls} photoUrls={photo_urls} size="64" />
              )}
              <p className="text-gray-500 text-body-3">{dayjs(created_at).format('MMM DD')}</p>
            </div>
            <Avatar uri={thumbnailUri} size="32" />
          </div>
        )
      })}
    </div>
  )
}

export default Conversation
